import { render, staticRenderFns } from "./AccountInvitationAccept.vue?vue&type=template&id=3334dfa9&"
import script from "./AccountInvitationAccept.vue?vue&type=script&lang=js&"
export * from "./AccountInvitationAccept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports